(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getFavorites() {
    try { return JSON.parse(localStorage.getItem('lmpFavorites') || '[]'); }
    catch (e) { return []; }
  }

  function setFavorites(items) {
    try { localStorage.setItem('lmpFavorites', JSON.stringify(items)); }
    catch (e) {}
  }

  function updateFavoriteButtons() {
    var favorites = getFavorites();
    document.querySelectorAll('[data-lmp-favorite]').forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      var active = favorites.some(function (item) { return item.handle === handle; });
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      var span = button.querySelector('span');
      if (span) span.textContent = active ? '♥' : '♡';
      if (!span && button.classList.contains('lmp-share-btn')) button.textContent = active ? '♥ Favorit gemerkt' : '♡ Favorit merken';
    });
  }


  function showFavoriteToast(title, added) {
    var toast = document.querySelector('[data-lmp-fav-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'lmp-fav-toast';
      toast.setAttribute('data-lmp-fav-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = added
      ? '<strong>Als Favorit gemerkt</strong><span>' + escapeText(title) + ' wurde gespeichert. Öffnen Sie oben die Merkliste oder teilen Sie Ihre Auswahl später als Link.</span><a class="lmp-fav-toast__link" href="/pages/favoriten">Merkliste ansehen</a>'
      : '<strong>Favorit entfernt</strong><span>' + escapeText(title) + ' wurde aus Ihrer Merkliste auf diesem Gerät entfernt.</span><a class="lmp-fav-toast__link" href="/pages/favoriten">Merkliste ansehen</a>';
    toast.classList.add('is-visible');
    clearTimeout(showFavoriteToast.timer);
    showFavoriteToast.timer = setTimeout(function () { toast.classList.remove('is-visible'); }, 3200);
  }

  function escapeText(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[char];
    });
  }

  function bindFavorites() {
    document.querySelectorAll('[data-lmp-favorite]').forEach(function (button) {
      if (button.dataset.lmpBound === 'true') return;
      button.dataset.lmpBound = 'true';
      button.addEventListener('click', function () {
        var handle = button.getAttribute('data-product-handle');
        var title = button.getAttribute('data-product-title') || handle;
        var favorites = getFavorites();
        var index = favorites.findIndex(function (item) { return item.handle === handle; });
        var added = false;
        if (index >= 0) {
          favorites.splice(index, 1);
        } else {
          favorites.push({ handle: handle, title: title, url: button.getAttribute('data-product-url') || '', addedAt: new Date().toISOString() });
          added = true;
        }
        setFavorites(favorites);
        updateFavoriteButtons();
        document.dispatchEvent(new CustomEvent('lmp:favorites:changed', { detail: { count: favorites.length } }));
        button.classList.add('is-fav-clicked');
        setTimeout(function(){ button.classList.remove('is-fav-clicked'); }, 360);
        showFavoriteToast(title, added);
      });
    });
  }

  function bindCardSearch() {
    document.querySelectorAll('[data-lmp-card-search]').forEach(function (input) {
      if (input.dataset.lmpBound === 'true') return;
      input.dataset.lmpBound = 'true';
      var target = input.getAttribute('data-lmp-card-search');
      var area = document.querySelector(target) || document;
      var empty = document.querySelector('[data-lmp-filter-empty]');
      input.addEventListener('input', function () {
        var value = input.value.trim().toLowerCase();
        var visible = 0;
        area.querySelectorAll('[data-lmp-product-card]').forEach(function (card) {
          var text = card.getAttribute('data-lmp-product-search') || card.getAttribute('data-lmp-product-title') || '';
          var match = !value || text.indexOf(value) !== -1;
          card.hidden = !match;
          if (match) visible += 1;
        });
        if (empty) empty.hidden = visible !== 0;
      });
    });
  }

  function bindAjaxCart() {
    document.querySelectorAll('[data-lmp-cart-form]').forEach(function (form) {
      if (form.dataset.lmpBound === 'true') return;
      form.dataset.lmpBound = 'true';
      form.addEventListener('submit', function (event) {
        if (!window.fetch) return;
        event.preventDefault();
        var button = form.querySelector('button[type="submit"]');
        var original = button ? button.textContent : '';
        if (button) {
          button.disabled = true;
          button.textContent = 'Wird hinzugefügt ...';
        }
        fetch(form.action, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json().catch(function () { return {}; });
        }).then(function (item) {
          var card = form.closest('[data-lmp-product-card]');
          if (card) {
            card.classList.add('is-added-to-cart');
            setTimeout(function () { card.classList.remove('is-added-to-cart'); }, 900);
          }
          if (button) button.textContent = 'Im Warenkorb ✓';
          document.dispatchEvent(new CustomEvent('lmp:cart:add', { detail: { title: item.product_title || item.title || '' } }));
          setTimeout(function () {
            if (button) {
              button.disabled = false;
              button.innerHTML = '<span class="lmp-card-btn__icon" aria-hidden="true">＋</span>Direkt in den Warenkorb';
            }
          }, 1700);
        }).catch(function () {
          form.submit();
        });
      });
    });
  }

  ready(function () {
    bindFavorites();
    updateFavoriteButtons();
    bindCardSearch();
    bindAjaxCart();
  });

  document.addEventListener('lmp:products:appended', function () {
    bindFavorites();
    updateFavoriteButtons();
    bindAjaxCart();
    bindCardSearch();
  });
})();
